import React from "react";

const Container = (props) => {
  return <div className="px-4 pb-4 pt-2 overflow-y-auto h-[calc(90vh-100px)]">{props?.children}</div>;
};

export default Container;
